import * as React from "react";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import "./filterButton.scss"
import Spinner from "../../../../hiberUiKit/src/atoms/Spinner/Spinner";
import classNames = require("classnames");
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";

const spinner = require("../../../../../resources/hiber/img/spinner-orange.png");

interface IProps {
	filterName: string;
	filterValue?: string;
	onRemove: () => void;
	onClick: () => void;
	isDisabled?: boolean;
	isLoading?: boolean;
	isNegated?: boolean
}

export default class FilterButton extends React.Component<IProps, {}> {
	constructor(props: IProps) {
		super(props);

		this.onRemove = this.onRemove.bind(this);
	}

	render() {
		const classes = classNames({
			"c-filter-button": true,
			"white": !this.props.filterValue
		});

		return (
			<button className={classes}
					onClick={() => !this.props.isDisabled && this.props.onClick()}
					disabled={this.props.isDisabled}>
				{this.props.filterName}
				{this.props.isNegated && <span className="negation-label">is not</span>}
				{this.props.filterValue && ":"}
				{!this.props.isLoading && this.props.filterValue && <span>{this.props.filterValue}</span>}
				{this.props.isLoading && <Spinner imgUrl={spinner}/>}
				<IconLarge icon={Icon.X} onClick={this.props.isDisabled ? null : this.onRemove}/>
			</button>
		)
	}

	onRemove(evt: React.MouseEvent<SVGSVGElement>) {
		evt.stopPropagation();
		this.props.onRemove();
	}
}